import Visual, { CreatorBase, CreatorLcdSize, CreatorZoom } from "./Visual";
import Pager from "./Pager";
import Checker from "./Checker";
import AddonList from "./AddonsList";
import ColorPicker from "./ColorPicker";
import CreatorForm from "./CreatorForm";
import Player360 from "./Player";

export default class Creator {
    public static INITAL_BASE = CreatorBase.TOWER1;
    public static INITAL_PAGE = 0;
    public static URL_UPDATE = '/?view=creator&action=update';

    public form: CreatorForm;

    public $el: JQuery;
    public $xbody: JQuery;
    public $summary: JQuery;
    public $summaryvis: JQuery;

    public vis: Visual;
    public pager: Pager;
    public player: Player360;

    public $vis: JQuery;

    public uploader;

    public cpb;
    public cpl;

    private options;

    public constructor($el: JQuery, options: any) {
        this.form = new CreatorForm(this);

        this.$el = $el;
        this.$xbody = $('.xbody', $el);

        this.$summaryvis = $('.xsummaryvis', $el);
        this.$summary = $('.xsummary', $el);

        this.options = options;

        this.initHtml();
    }

    private getBaseName(id: number): string {
        switch (id) {
            case 1:
                return 'tower';

            case 2:
                return 'tower2';

            case 5:
                return 'desktop1';

            case 6:
                return 'desktop2';

            case 7:
                return 'desktop3';

            case 10:
                return 'mobile';
        }
    }

    private getAddons(): any {
        var result=[];

        $('.xpage-addons .boxitem', this.$el).each(function () {
            var $item=$(this);
            var check=$item.find('.xcheck').data('xcheck');

            if (check.isChecked()) {
                result.push($item);
            }
        });

        return result;
    }

    public getBase(): number {
        var id = $('.xpage-base input[name="base"]:checked').val();

        return id ? parseInt(id) : null;
    }

    private isMobileX(): boolean {
        var base_id = this.getBase();

        if (base_id != CreatorBase.MOBILE) {
            return false;
        }

        var addons = this.getAddons();

        var mobilex = false;

        $.each(addons, function(ix, $boxitem) {
            if (!$boxitem.hasClass('boxitem--mobile-small')) {
                mobilex = true;
                return false;
            }
        });

        return mobilex;
    }

    public updateCart(): void {
        if (this.form.bypass_update) {
            return;
        }

        this.$summary.addClass('loading');
        this.$summaryvis.addClass('loading');

        let data = $(':input:not(:disabled)', this.$el).serializeArray();

        $.post(Creator.URL_UPDATE, data, (r) => {
            if (r.success) {
                this.$summaryvis.html(r.vis.html);
                this.$summaryvis.removeClass('loading');

                this.$summary.html(r.summary.html);
                this.$summary.removeClass('loading');
            }
        });
    }

    public updateVis(): void {
        var base_id = this.getBase();
        var mobilex = this.isMobileX();

        this.vis.setMobileX(mobilex);
        this.vis.setBase(base_id);
        this.vis.setBaseColor(this.form.getValueInt('basecolor'));
        this.vis.setLcdColor(this.form.getValueInt('lcdcolor'));

        if (this.form.getValueInt('lcd-50') == 1) {
            this.vis.setLcdSize(CreatorLcdSize.LCD5);
        } else if (this.form.getValueInt('lcd-51') == 1) {
            this.vis.setLcdSize(CreatorLcdSize.LCD7);
        }

        this.vis.setOxy(this.form.getValueInt('a-113') == 1);
        this.vis.setAddonsVisible(this.pager.isPageAddons());

        if (this.form.bypass_update) {
            return;
        }

        this.vis.update();

        var boxes=[];
        var addons = this.getAddons();

        $.each(addons, function () {
            var found=false;

            for (var i=1; i<=3; i++) {
                var image=$(this).data('image' + i);

                if (image!=null && image.length>0) {
                    found=true;
                    break;
                }
            }

            if (found) {
                boxes.push(this);
            }
        });

        this.vis.setBoxes(boxes);
    }

    public updateLayout(): void {
        if (this.form.bypass_update) {
            return;
        }

        this.pager.updateLayout();
        this.updateVis();
    }

    public oneOfCheck($main, required): void {
        let This = this;

        this.form.$bypass_checks = this.form.$bypass_checks.add($main);

        $main.each(function () {
            var $this=$(this);
            var check=$this.data('xcheck');

            check.onChange(function (value) {
                if (!This.form.bypass_checkers) {
                    This.form.bypass_checkers=true;

                    if (value) {
                        $main.not($this).each(function () {
                            $(this).data('xcheck').setChecked(false);
                        });
                    } else if (required) {
                        $main.first().data('xcheck').setChecked(true);
                    }

                    This.updateVis();
                    This.updateCart();
                    This.form.bypass_checkers=false;
                }
            });
        });
    }

    public setBase(id: number): void {
        var $addons = $('.xpage-addons .boxitem', this.$el);
        var $addons_ok = $addons.filter('.boxitem--for-' + id);

        $addons_ok.show();
        $addons.not($addons_ok).hide().each(function() {
            $('.xcheck', $(this)).data('xcheck').setChecked(false);
        });

        $addons_ok.show();
        $addons.not($addons_ok).hide().each(function() {
            $('.xcheck', $(this)).data('xcheck').setChecked(false);
        });

        var $basecolors = $('.xpage-basecolor .basepalette__item', this.$el);
        var $basecolors_ok = $basecolors.filter('.basepalette__item--for-' + id);

        $basecolors_ok.show();
        $basecolors.not($basecolors_ok).hide();

        $('.xpage-basecolor .basepalette', this.$el).toggleClass('basepalette--2', id == CreatorBase.MOBILE);

        this.form.getCheckByName('lcd-50').setDisabled(id == CreatorBase.TOWER2);
        this.form.getCheckByName('lcd-51').setDisabled(id == CreatorBase.TOWER2);

        let $lcdsizes = $('.xpage-lcdcolor__sizes', this.$el);

        if (id == CreatorBase.TOWER2) {
            $lcdsizes.hide();
        } else {
            $lcdsizes.show();
        }

        switch (id) {
            case CreatorBase.MOBILE:
                this.cpb.setColor(22);
                break;

            case CreatorBase.TOWER1:
                this.cpb.setColor(209016);
                break;

            case CreatorBase.TOWER2:
                this.cpb.setColor(209016);
                break;

            case CreatorBase.DESKTOP1:
                this.cpb.setColor(209016);
                break;

            case CreatorBase.DESKTOP2:
                this.cpb.setColor(209016);
                break;

            case CreatorBase.DESKTOP3:
                this.cpb.setColor(209016);
                break;

            default:
                throw "Unknown creator base id " + id;
        }

        this.player.show(this.getBaseName(id));

        this.updateLayout();
        this.updateCart();
    }

    private initChecks(): void {
        let This = this;

        var $main=this.$el.find('.xcheck');

        this.$el.find('.xcheck-oneof').each(function () {
            var $list=$(this).find('.xcheck');

            $list.each(function () {
                var check=new Checker($(this));
            });

            This.oneOfCheck($list, true);
        });

        AddonList.create(this, [113], [114, 121, 205]);
        AddonList.create(this, [115, 116], [206]);
        AddonList.create(this, [118, 119]);
        AddonList.create(this, [107], [108]);
        AddonList.create(this, [109], [110]);
        AddonList.create(this, [100, 101, 102, 104, 105, 106], [103]);

        $main.not(this.form.$bypass_checks).each(function () {
            var $this = $(this);

            var check=new Checker($this);

            check.onChange(function() {
                This.updateVis();
                This.updateCart();
            });
        });
    }

    private initSteps(): void {
        var $xpage_base = $('.xpage-base', this.$el);
        var $xpage_basecolor = $('.xpage-basecolor', this.$el);
        var $xpage_lcdcolor = $('.xpage-lcdcolor', this.$el);
        var $xpage_logo = $('.xpage.xpage-logo', this.$el);
        var $xpage_addons = $('.xpage-addons', this.$el);
        var $xpage_train = $('.xpage-training', this.$el);

        var $input_base = $('input', $xpage_base);

        $input_base.change(() => {
            this.setBase(parseInt($input_base.filter(':checked').val()));
        });

        this.cpb = new ColorPicker({
            picker: $('.colorpicker', $xpage_basecolor),
            name: 'basecolor',
            palette: $('.basepalette', $xpage_basecolor),

            defaultcolor: this.options.defaultColorBase,

            onChange: (id) => {
                this.updateLayout();
                this.updateCart();
            }
        });

        this.cpl = new ColorPicker({
            picker: $('.colorpicker', $xpage_lcdcolor),
            name: 'lcdcolor',
            palette: $('.lcdpalette', $xpage_lcdcolor),

            defaultcolor: this.options.defaultColorLCD,

            onChange: (id) => {
                this.updateLayout();
                this.updateCart();
            }
        });

        var $xcustom = $('.xcustom', $xpage_logo);
        $xcustom.hide();

        this.form.getCheck('.ilogocustom').onChange(function(c) {
            if (c) {
                $xcustom.slideDown();
            } else {
                $xcustom.slideUp();
            }
        });

        this.uploader = $('.uploader', this.$el).data('uploader');

        this.uploader.onChange((data) => {
            this.updateLayout();
            this.updateCart();
        });

        $('.boxitem', $xpage_addons).each(function() {
            var $item=$(this);

            let $text = $('.boxitem__text', $item);

            $item.find('.inner').click(function (e) {
                e.preventDefault();

                var $check=$item.find('.xcheck');
                $check.click();
            });

            $item.hover(
                (e) => {
                    let pos = $item.offset();
                    pos.left -= $(document).scrollLeft();
                    pos.top -= $(document).scrollTop();

                    pos.top += 10;
                    pos.left += $item.width() + 4;

                    $text.css({
                        left: pos.left,
                        top: pos.top
                    });

                    $item.addClass('boxitem--hover');
                },

                () => {
                    $item.removeClass('boxitem--hover');
                }
            );

            $text.hover(() => {
                $item.removeClass('boxitem--hover');
            });
        });
    }

    public reset(update: boolean): void {
        this.form.bypass_update = true;

        this.cpb.reset();
        this.cpl.reset();

        this.form.getCheckByName('lcd-50').setChecked(true);
        this.form.getCheckByName('notraining').setChecked(true);
        this.form.getCheckByName('logostandard').setChecked(true);

        var $addons=this.$el.find('.xpage-addons .xcheck');
        $addons.each(function() {
            $(this).data('xcheck').setChecked(false);
        });

        $('input[name="base"][value="' + Creator.INITAL_BASE + '"]').prop('checked', true);
        this.setBase(this.getBase());
        this.pager.switchTo(Creator.INITAL_PAGE);

        this.form.bypass_update=false;

        if (update) {
            this.updateVis();
            this.updateCart();
        }
    }

    public downloadPdf(): void {
        this.$summary.addClass('loading');

        var url=this.$el.data('url') + '&pdf=1';
        var data=this.$el.find(':input').serializeArray();

        $.post(url, data, (response) => {
            this.$summary.removeClass('loading');
            (<any> window).location = url;
        });
    }

    public submit(): void {
        this.$summary.addClass('loading');

        var data = this.form.getData();

        $.post(this.$el.data('url'), data, (response) => {
            this.$summary.removeClass('loading');
        });
    }

    public initHtml(): void {
        let This = this;

        this.$vis = this.$el.find('.xvis');

        this.$el.data('creator', this);

        this.pager = new Pager(this);

        this.pager.onValidate((ix, $xpage) => {
            switch (ix) {
                case 1:
                    return $('.xpage-base input[name="base"]:checked').length > 0;

                case 2:
                    return $('.xpage-basecolor input[name="basecolor"]').val() != '';

                case 3:
                    return $('.xpage-lcdcolor input[name="lcdcolor"]').val() != '';
            }
        });

        this.pager.onChange((ix) => {
            this.vis.setZoom(CreatorZoom.FAR);

            var base_id = this.getBase();

            if (ix == 0) {
                this.vis.setZoom(CreatorZoom.PLAYER360);
            } else {
                if (base_id != CreatorBase.TOWER1 && base_id != CreatorBase.TOWER2) {
                    this.vis.setZoom(CreatorZoom.NEAR);
                } else if (ix == 2 || ix == 3) {
                    this.vis.setZoom(CreatorZoom.NEAR);
                }
            }

            this.updateVis();
        });

        this.initChecks();
        this.initSteps();

        this.player = new Player360($('.player360', this.$el));

        this.vis = new Visual(this.$vis);

        This.reset(false);

        this.vis.initHtml();

        this.updateVis();
        this.updateCart();
    }
}
